<div class="summary-card flex-column p-0 d-print-none" *ngIf="entrySummary && entrySummary.shipments && entrySummary.shipments.length">
  <div class="summary-card-content pb-2">
    <div class="summary-card-header">
      <div>
        <h5>{{ "DOCUMENTS.ATTACH_DOCUMENTS" | translate }}:</h5>
      </div>
    </div>

    <div class="container-card-body">
      <div class="description d-none d-md-block">
        {{ "DOCUMENTS.UPLOAD_DOCUMENTS_DESCRIPTION" | translate : { billName: billName | translate } }}
      </div>
      <div class="description d-md-none">
        {{ "DOCUMENTS.UPLOAD_DOCUMENTS_DESCRIPTION_MOBILE" | translate : { billName: billName | translate } }}
      </div>

      <!-- POA Document - New (with DocuSign sidebar) -->
      <ng-container *ngIf="hasPoaDocusignFlag; else oldPoaTemplate">
        <div class="mb-2 p-0" *ngIf="isShowPoaDocument">
          <es-poa-document-download
            [attachmentTypeName]="'COMPANY.POWER_OF_ATTORNEY_SIGN_TYPE'"
            [attachmentName]="'DOCUMENT_TYPE.' + enumDocumentType[poaAttachedDocument.type]"
            [document]="poaAttachedDocument"
            [isOverrideDefaultRequired]="isOverrideDefaultPoaRequired"
            [isCanUploadDocuments]="isCanUploadDocuments"
            [isCanRemoveDocuments]="isCanRemoveDocuments"
            [validationMessages]="validationMessages"
            [upload]="uploadCompanyFile"
            [remove]="removeFile"
            [openPoaSidebar]="openPowerOfAttorneySidebar"
            [managePoaFooterHint]="'COMPANY.MANAGE_POA_FROM_SIDEBAR'"
            (stateUpdate)="onStateUpdate($event)"
          ></es-poa-document-download>
        </div>
      </ng-container>
      <!-- POA Document - Old (without DocuSign sidebar) -->
      <ng-template #oldPoaTemplate>
        <div class="mb-2" *ngIf="isShowPoaDocument">
          <es-poa-document-download
            [attachmentTypeName]="'LABELS.ENTRY_SUMMARY'"
            [attachmentName]="'DOCUMENT_TYPE.' + enumDocumentType[poaAttachedDocument.type]"
            [document]="poaAttachedDocument"
            [isOverrideDefaultRequired]="isOverrideDefaultPoaRequired"
            [isCanUploadDocuments]="isCanUploadDocuments"
            [isCanRemoveDocuments]="isCanRemoveDocuments"
            [validationMessages]="validationMessages"
            [upload]="uploadCompanyFile"
            [remove]="removeFile"
            (stateUpdate)="onStateUpdate($event)"
          ></es-poa-document-download>
        </div>
      </ng-template>

      <div class="mb-2" *ngIf="isShowPunDocument">
        <es-pun-document-download
          [attachmentTypeName]="'LABELS.ENTRY_SUMMARY'"
          [attachmentName]="'DOCUMENT_TYPE.' + enumDocumentType[punAttachedDocument.type]"
          [document]="punAttachedDocument"
          [isCanUploadDocuments]="isCanUploadDocuments"
          [isCanRemoveDocuments]="isCanRemoveDocuments"
          [validationMessages]="validationMessages"
          [upload]="uploadCompanyFile"
          [remove]="removeFile"
          (stateUpdate)="onStateUpdate($event)"
        ></es-pun-document-download>
      </div>

      <div *ngIf="otherAttachedDocuments && otherAttachedDocuments.length" class="mb-2">
        <div *ngFor="let document of otherAttachedDocuments">
          <es-document-download
            [attachmentTypeName]="'LABELS.ENTRY_SUMMARY'"
            [attachmentName]="'DOCUMENT_TYPE.' + enumDocumentType[document.type]"
            [document]="document"
            [isCanUploadDocuments]="isCanUploadDocuments"
            [isCanRemoveDocuments]="isCanRemoveDocuments"
            [validationMessages]="validationMessages"
            [remove]="removeFile"
            (stateUpdate)="onStateUpdate($event)"
          ></es-document-download>
        </div>
      </div>

      <div *ngIf="deliveryOrderAttachedDocuments && deliveryOrderAttachedDocuments.length" class="mb-2">
        <div *ngFor="let document of deliveryOrderAttachedDocuments">
          <es-document-download
            [attachmentTypeName]="'DOCUMENT_TYPE.' + enumDocumentType[document.type]"
            [attachmentName]="document.params.referenceNumber"
            [document]="document"
            [isCanUploadDocuments]="isCanUploadDocuments"
            [isCanRemoveDocuments]="isCanRemoveDocuments"
            [validationMessages]="validationMessages"
            [remove]="removeFile"
            (stateUpdate)="onStateUpdate($event)"
          ></es-document-download>
        </div>
      </div>

      <div *ngIf="notAttachedDocuments && notAttachedDocuments.length" class="mb-2">
        <div *ngFor="let document of notAttachedDocuments">
          <es-document-download
            [attachmentTypeName]="'LABELS.ENTRY_SUMMARY'"
            [attachmentName]="'DOCUMENT_TYPE.' + enumDocumentType[document.type]"
            [document]="document"
            [isCanUploadDocuments]="isCanUploadDocuments"
            [isCanRemoveDocuments]="isCanRemoveDocuments"
            [validationMessages]="validationMessages"
            [remove]="removeFile"
            (stateUpdate)="onStateUpdate($event)"
          ></es-document-download>
        </div>
      </div>

      <div *ngFor="let shipment of entrySummary.shipments; let index = index">
        <es-bill-lading-attach-document
          [isCanUploadDocuments]="isCanUploadDocuments"
          [isCanRemoveDocuments]="isCanRemoveDocuments"
          [attachedDocuments]="attachedDocuments"
          [shipment]="shipment"
          [entrySummaryId]="entrySummary.id"
          [validationMessages]="validationMessages"
          [isShowEmptyLineItemDocuments]="isShowEmptyLineItemDocuments"
          [currentShipmentIndex]="index + 1"
          [upload]="uploadFile"
          [remove]="removeFile"
          [billName]="billName"
          [isTruck]="isTruck"
          (stateUpdate)="onStateUpdate($event)"
        ></es-bill-lading-attach-document>
      </div>

      <button
        class="btn btn-link d-block mt-2"
        type="button"
        *ngIf="isUploadedAnyFiles && !isHideDownloadAll"
        (click)="onDownloadAllFiles()"
      >
        <i class="fa fa-download" aria-hidden="true"></i>
        <span>
          {{ "LABELS.DOWNLOAD_ALL_FILES" | translate }}
        </span>
      </button>
    </div>
  </div>
</div>
